module.exports = function() {
  return new Worker(__webpack_public_path__ + "b63526657dfc4919ef29.worker.js");
};